import {Flexbox} from '@/components/ui/flexbox/FlexBox'
import {AlertCircleIcon, CheckIcon, ClockRewindIcon} from '@/components/ui/icon/Icon'
import {useTranslation} from '@/translations/i18n'
import {HTMLAttributes, ReactNode, useMemo} from 'react'
import {Text} from '@/components/ui/text/Text'
import {useTheme} from 'styled-components'

export const DetailsInformationObservedField = <T extends string>({
    fieldsToUpdate,
    hideIcons,
    ...props
}: HTMLAttributes<HTMLDivElement> & {
    name: T
    value: ReactNode
    hideIcons?: ['success' | 'pending' | 'missing']
    fieldsToUpdate?: string[] | null
}) => {
    const {t} = useTranslation()
    const isToUpdate = useMemo(
        () => fieldsToUpdate && fieldsToUpdate.includes(props.name),
        [props.name, fieldsToUpdate]
    )

    const {palette} = useTheme()
    return (
        <div {...props}>
            {props.value ? (
                isToUpdate ? (
                    <Flexbox direction="column" gap={1}>
                        <Text weight="500" size="textMd" palette="neutral" shade="950">
                            {props.value}
                        </Text>
                        <Flexbox gap={1} align="center">
                            {!hideIcons?.includes('pending') && (
                                <ClockRewindIcon size={16} color={palette.orange[500]} />
                            )}
                            <Text size="textSm" palette="orange" weight="500" shade="800">
                                {t('users:to_update')}
                            </Text>
                        </Flexbox>
                    </Flexbox>
                ) : (
                    <Flexbox gap={1} align="center">
                        {!hideIcons?.includes('success') && <CheckIcon size={16} color={palette.green[800]} />}
                        <Text size="textMd" palette="green" weight="500" shade="800">
                            {props.value}
                        </Text>
                    </Flexbox>
                )
            ) : (
                <Flexbox align="center" gap={1}>
                    {!hideIcons?.includes('missing') && <AlertCircleIcon size={16} color={palette.orange[500]} />}
                    <Text size="textSm" palette="orange" weight="500" shade="800">
                        {t('users:to_compile')}
                    </Text>
                </Flexbox>
            )}
        </div>
    )
}
